import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorMessagesPipe } from '../../pipes/error-messages.pipe';

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    ErrorMessagesPipe
  ],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent {
  @Input() label = '';
  @Input() control: FormControl = new FormControl();

  @Input() options: Array<string | { key: any; value: any }> = [];
  @Input() placeholder?: string;
  @Input() messages: any = {};
  @Input() isViewMode: boolean = false;
  @Input() value: string | any; // Define value as an input
  @Output() change = new EventEmitter<string>();
  @Input() disabled: boolean = false;
  @Input() multiple = false;
  @Input() showErrors: boolean = false;
  constructor() { }

  // ngOnInit() {
  //   this.syncDisabledState();
  // }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['isViewMode'] || changes['disabled']) {
  //     this.syncDisabledState();
  //   }
  // }


  onTouched = () => { };

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  isObject(option: any): option is { key: any; value: any } {
    return typeof option === 'object' && option !== null && 'key' in option && 'value' in option;
  }

  onSelectionChange(event: any): void {
    const selectElement = event.target as HTMLSelectElement;
    this.value = selectElement.value;
    this.change.emit(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if needed
  }

  getControlName(control: FormControl) {
    // return this.formUtils.getControlName(control);
  }


  isFieldRequired(control: AbstractControl | null): boolean {
    if (!control) {
      return false;
    }

    return control.hasValidator(Validators.required);
  }
}
